import { func, node, oneOfType, shape, string } from 'prop-types'

import reactComponentSignatureSchema from './reactComponentSignature'

export default oneOfType([
  node,
  shape({
    key: string.isRequired,
    draggableProps: shape({
      'aria-label': string.isRequired,
      'aria-roledescription': string.isRequired,
      as: reactComponentSignatureSchema,
      className: string,
      draggingClassName: string,
      onBlur: func,
      onFocus: func,
      onKeyDown: func,
    }),
    element: node,
  }),
])
